import axios, { type AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';

export const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  timeout: 35000 
});

apiClient.interceptors.request.use((config) => {
  return config;
});

axiosRetry(apiClient, {
  retries: 3,
  retryDelay: (retryCount, error) => {
    const delay = axiosRetry.exponentialDelay(retryCount);
    return delay;
  },
  retryCondition: (error) => {
    const shouldRetry = axiosRetry.isNetworkOrIdempotentRequestError(error) || error.code === 'ECONNABORTED';
    return shouldRetry;
  }
});

apiClient.interceptors.response.use(null, (error) => {
  return Promise.reject(error);
});

export const utils = {
  formatDate : (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
};